/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetStagedAltArtResponse } from '../../models/get-staged-alt-art-response';

export interface AdminServiceGetStagedAltArt$Params {
}

export function adminServiceGetStagedAltArt(http: HttpClient, rootUrl: string, params?: AdminServiceGetStagedAltArt$Params, context?: HttpContext): Observable<StrictHttpResponse<GetStagedAltArtResponse>> {
  const rb = new RequestBuilder(rootUrl, adminServiceGetStagedAltArt.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetStagedAltArtResponse>;
    })
  );
}

adminServiceGetStagedAltArt.PATH = '/api/v3/gateway/admin/stage/alt_art';
